<template lang="pug">
div.loyalty-template-conv
  h1.loyalty-template-conv__title {{ $t('loyalty.couponCoversion') }}
  span.loyalty-template-conv__data {{ $t('loyalty.BasedOnBonus') }}
  div.loyalty-template-conv__espaciado
  h2.loyalty-template-conv__subtitle {{ $t('loyalty.pointToRedeemed') }}
  span.loyalty-template-conv__data {{ data.ptos_fijo }}
  div.loyalty-template-conv__espaciado
  h2.loyalty-template-conv__subtitle {{ $t('loyalty.amountValue') }}
  span.loyalty-template-conv__data {{ data.imp_equival }}
  div.loyalty-template-conv__espaciado
  h2.loyalty-template-conv__subtitle {{ $t('loyalty.roundToPoints') }}
  span.loyalty-template-conv__data {{ data.redondeo || $t('loyalty.noData') }}
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'DatosPlantilla'
}
</script>
<style lang="scss">
.loyalty-template-conv{
  .ods-module__body{
    padding: 0;
  }
  &__espaciado{
  padding-bottom: rem(24);
  }
  &__data{
   padding-left: rem(32);
   font-size: rem(12);
   line-height: rem(24);
  }
  &__title{
    font-size: rem(14);
    line-height: rem(24);
    margin-bottom: rem(16);
    margin-left: rem(32);
    margin-top: rem(32);
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(9);
    line-height: rem(16);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
    margin-left: rem(32);
  }
}
</style>
